<div class='branch-details'>
    <app-branch-details-org [card]='card' [compact]='compact'></app-branch-details-org>
    <app-branch-details-address [card]='card' [compact]='compact'></app-branch-details-address>
</div>
